const crudEndpoints = (base) => {
    return {
        getItems: {
            path: "/api/v2/" + base,
            method: "get",
            requiresAuth: true,
        },
        getItemCount: {
            path: "/api/v2/" + base + "/count",
            method: "get",
            requiresAuth: true,
        },
        getItem: (id) => {
            return {
                path: "/api/v2/" + base + "/" + id,
                method: "get",
                requiresAuth: true,
            }
        },
        deleteItem: (id) => {
            return {
                path: "/api/v2/" + base + "/" + id,
                method: "delete",
                requiresAuth: true,
            }
        },
        updateItem: (id) => {
            return {
                path: "/api/v2/" + base + "/" + id,
                method: "put",
                requiresAuth: true,
            }
        },
        resendInvite: (id,clubId) => {
            return {
                path: "/api/v2/" + base + "/" + id+ "/resend/"+clubId,
                method: "get",
                requiresAuth: true,
            }
        },
        addItem: {
            path: "/api/v2/" + base,
            method: "post",
            requiresAuth: true,
        }
    }
}

export const endpoints = {
    contact: {
        message: {
            path: "/api/v2/contact",
            method: "post",
            requiresAuth: false,
        }
    },
    auth: {
        login: {
            path: "/api/v2/auth/login",
            method: "post",
            requiresAuth: false,
        },
        register: {
            path: "/api/v2/auth/me",
            method: "post",
            requiresAuth: false,
        },
        forgotPassword: {
            path: "/api/v2/auth/forgot-password",
            method: "post",
            requiresAuth: false,
        },
        validateShortLivedToken: (token) => {
            return {
                path: "/api/v2/auth/short-lived-token-validate",
                method: "get",
                requiresAuth: false,
            }
        },
        validateToken: (token) => {
            return {
                path: "/api/v2/auth/validate/" + token,
                method: "get",
                requiresAuth: false,
            }
        },
        acceptInvite: (token,data) => {
            return {
                path: "/api/v2/auth/validate/" + token + "/accept",
                method: data ? "post" : "get",
                requiresAuth: false,
            }
        },
        rejectInvite: (token) => {
            return {
                path: "/api/v2/auth/validate/" + token + "/accept",
                method: "delete",
                requiresAuth: false,
            }
        },
        createPassword: {
            path: "/api/v2/auth/validate",
            method: "post",
            requiresAuth: false,
        },
        me: {
            path: "/api/v2/auth/me",
            method: "get",
            requiresAuth: true,
        },
        meUpdate: {
            path: "/api/v2/auth/me",
            method: "put",
            requiresAuth: true,
        },
        meDelete: {
            path: "/api/v2/auth/me",
            method: "delete",
            requiresAuth: true,
        },
        mePassword: {
            path: "/api/v2/auth/me/password",
            method: "put",
            requiresAuth: true,
        },
        meServices: {
            path: "/api/v2/auth/me/externalServices",
            method: "put",
            requiresAuth: true,
        },
        mePicture: {
            path: "/api/v2/auth/me/picture",
            method: "put",
            requiresAuth: true,
        }
    },
    uploads: {
        getItems: {
            path: "/api/v2/uploads",
            method: "get",
            requiresAuth: true,
        },
        getItem: (id, size) => {
            return {
                path: "/api/v2/uploads/" + id + "/" + size,
                method: "get",
                requiresAuth: true,
            }
        },
        addItem: {
            path: "/api/v2/uploads",
            method: "post",
            requiresAuth: true,
        }
    },
    pendingUsers: {
        getItems: (clubId) => {
            return {
                path: "/api/v2/users/pending/club/" + clubId,
                method: "get",
                requiresAuth: true,
            }
        },
        deleteItem: (pendingUserId) => {
            return {
                path: "/api/v2/users/pending/" + pendingUserId,
                method: "delete",
                requiresAuth: true,
            }
        }
    },
    teams: {
        ...crudEndpoints("teams"),
    },
    players: {
        ...crudEndpoints("players"),
        deleteFromClub: (playerId, clubId) => {
            return {
                path: "/api/v2/players/" + playerId + "/club/" + clubId,
                method: "delete",
                requiresAuth: true,
            }
        }
    },
    howTos: {
        ...crudEndpoints("howTos"),
    },
    howToCategories: {
        ...crudEndpoints("howToCategories"),
    },
    howToKeywords: {
        ...crudEndpoints("howToKeywords"),
    },
    accessApplications: {
        ...crudEndpoints("accessApplications"),
    },
    users: {
        ...crudEndpoints("users"),
        getPicture: (id, size) => {
            return {
                path: "/api/v2/users/" + id + "/picture/" + size,
                method: "get",
                requiresAuth: true,
            }
        },
        getRequest: (id) => {
            return {
                path: "/api/v2/users/requests/" + id,
                method: "get",
                requiresAuth: true
            }
        },
        approveRequest: {
            path: "/api/v2/users/requests",
            method: "put",
            requiresAuth: true
        },
        getRequests: {
            path: "/api/v2/users/requests",
            method: "get",
            requiresAuth: true,
        },
        addRequest: {
            path: "/api/v2/users/requests",
            method: "post",
            requiresAuth: true,
        },
        cancelRequest: (id) => {
            return {
                path: "/api/v2/users/requests/" + id,
                method: "delete",
                requiresAuth: true,
            }
        },
        mail: {
            path: "/api/v2/users/mail",
            method: "post",
            requiresAuth: true,
        },
        getPendingItems: {
            path: "/api/v2/users/pending",
            method: "get",
            requiresAuth: true,
        },
        deletePendingItem: (id) => {
            return {
                path: "/api/v2/users/pending/" + id,
                method: "delete",
                requiresAuth: true,
            }
        },
        impersonate: (id) => {
            return {
                path: "/api/v2/users/" + id + "/impersonate",
                method: "get",
                requiresAuth: true,
            }
        },
    },
    chats : {
        create: {
            path: "/api/v2/chat",
            method: "post",
            requiresAuth : true,
        }
    },
    clubs: {
        ...crudEndpoints("clubs"),
        logo: (clubId) => {
            return {
                path: "/api/v2/clubs/" + clubId + "/logo",
                method: "put",
                requiresAuth: true,
            }
        },
        toDo: {
            path: "/api/v2/clubs/todo",
            method: "get",
            requiresAuth: true,
        }
    },
    leagues: {
        ...crudEndpoints("leagues"),
    },
    ladders: {
        ...crudEndpoints("ladders"),
        pdf: (id) => {
            return {
                path: "/api/v2/ladders/" + id + "/pdf",
                method: "get",
                requiresAuth: true,
            }
        },
    },
    ladderChallenges: {
        ...crudEndpoints("ladderChallenges")
    },
    leagueCycles: {
        ...crudEndpoints("leagueCycles"),
        pdf: (id, type) => {
            return {
                path: "/api/v2/leagueCycles/" + id + "/pdf?type=" + type,
                method: "get",
                requiresAuth: true,
            }
        },
    },
    leagueCycleDivisions: {
        ...crudEndpoints("leagueCycleDivisions"),

    },
    leagueDivisions: {
        ...crudEndpoints("leagueDivisions"),
        move: (divisionId, isUp) => {
            return {
                path: "/api/v2/leagueDivisions/" + divisionId + "/move/" + isUp,
                method: "get",
                requiresAuth: true,
            }
        },
    },
    fixtures: {
        ...crudEndpoints("fixtures"),
        export: {
            path: "/api/v2/fixtures/export",
            method: "get",
            requiresAuth: true,
        }
    },
    scoringSystems: {
        ...crudEndpoints("scoringSystems"),
    },
    sports: {
        ...crudEndpoints("sports"),
    },
    countries: {
        getItems: {
            path: "/api/v2/countries",
            method: "get",
            requiresAuth: false,
        },
    }
}
